import { Module } from '@moonpig/web-shared-products'

export const createCardFrictionlessFlowNoECardConfiguration = (): Module[] => {
  return [
    {
      __typename: 'ModuleTwoColumn',
      left: [{ __typename: 'ModuleImages' }],
      right: [
        { __typename: 'ModuleHeading' },
        { __typename: 'ModuleMemberPricingHeader' },
        { __typename: 'ModuleFromPriceFrictionless' },
        { __typename: 'ModulePromotions' },
        { __typename: 'ModuleDispatch' },
        { __typename: 'ModuleButtons' },
      ],
    },
  ]
}
